import Vue from 'vue'

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

Vue.directive('focusonempty', {
  inserted: function (el) {
    if (!el.value) {
      el.focus()
    }
  }
})



// WEBPACK FOOTER //
// ./src/directives/index.js